import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e29eae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper vh-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワード設定", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "\n            パスワードを入力しましょう\n          ", -1))

import { ref } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import Header from "@/components/organisms/common/Header.vue";
import { accountService } from "@/app/services/AccountService";
import { authService } from "@/app/services/AuthService";
import { authStore } from "@/store/auth";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import PasswordInputGroup from "@/components/molecules/form/PasswordInputGroup.vue";
import { captureException } from "@/plugins/sentry";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";
import { AbTest3113 } from "@/app/services/AbTestService";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSetting',
  setup(__props) {

const errorModal = useErrorModal();
const modal = useModal();
const loader = useLoader();
const customRouter = useCustomRouter();

const password = ref("");
const requesting = ref(false);

onMounted(() => {
  // 簡単にpasswordのinputを取れないのでqueryで取得
  const passwordInput = document.querySelector<HTMLInputElement>(
    "[type='password']"
  );
  if (passwordInput) passwordInput.focus();
});

async function nextStep() {
  try {
    // 連打防止
    if (requesting.value) return;

    // registration がコールされた後、ログインステータスの値はクリアされてしまう
    // 後続処理で利用したいので、ここで取得しておく
    const workerLoginStatus = authStore.workerLoginStatus;

    requesting.value = true;
    loader.show();
    await registration();
    AbTest3113.registerEvent(AbTest3113.eventTypes.enterPasswordNext);
    sendAdjustEvent("FINISH_INPUT_PASSWORD");
    sendFirebaseCustomEvent("finish_input_password", {
      session_id: authStore.sessionId || "unknown"
    });

    try {
      // authService.registration でユーザーレコードが生成される
      // アプリの場合、上記で生成されたユーザーレコードに起動に関する情報を記録する
      const cordova = window.cordova;
      if (cordova && authStore.user) {
        await accountService.recordAppBoot();
      }
      // ODM の初期設定
      authStore.initiateOnDeviceConversionMeasurement();
    } catch (e) {
      // アプリの挙動には影響ないため、エラー通知はするが処理は続行する
      captureException(e as Error);
    }

    // 認証済みの退会ユーザーだった場合、以降の認証処理はスキップする
    if (workerLoginStatus === "verified_leave_user") {
      await customRouter.pushIgnoreError({ name: "Search" });
      return;
    }

    await customRouter.pushIgnoreError({ name: "RegisterPersonalInfo" });
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any;
    // smsSessionIdが不正な場合
    if (err.response.data.smsSessionId) {
      await modal.msgBoxOk("不正な操作です", {
        centered: true
      });
      await customRouter.pushIgnoreError({ name: "Welcome" });
      return;
    }

    // 既に登録済みの場合
    if (err.response.data.nonFieldErrors) {
      await errorModal.showErrorModal(err);
      await customRouter.pushIgnoreError({ name: "Welcome" });
      return;
    }
    // それ以外の場合
    await errorModal.showErrorModal(err);
  } finally {
    loader.hide();
    requesting.value = false;
  }
}

function registration() {
  const body = {
    smsSessionId: authStore.smsSessionId as string,
    password: password.value
  };
  // 退会ユーザーだった場合は復帰処理を行う
  if (
    ["unverified_leave_user", "verified_leave_user"].includes(
      authStore.workerLoginStatus!
    )
  ) {
    return authService.reactivateWorker(body);
  }
  return authService.registration(body);
}

return (_ctx: any,_cache: any) => {
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, null, {
      default: _withCtx(() => [
        _hoisted_2
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, { tag: "div" }, {
      default: _withCtx(({ handleSubmit, valid }) => [
        _createVNode(_component_BForm, {
          class: "container",
          onSubmit: _withModifiers(($event: any) => (handleSubmit(nextStep)), ["prevent","stop"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("main", null, [
              _hoisted_3,
              _createTextVNode(),
              _createVNode(PasswordInputGroup, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                class: "password-input",
                strict: "",
                helpText: "半角英字と数字を組み合わせて8文字以上で設定してください"
              }, null, 8, ["modelValue"]),
              _createTextVNode(),
              _createVNode(AppButton, {
                block: "",
                rounded: "",
                onClick: ($event: any) => (handleSubmit(nextStep)),
                class: "next-button",
                disabled: !valid
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            設定して次へ\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ])
          ], undefined, true),
          _: 2
        }, 1032, ["onSubmit"])
      ]),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(BlockBack)
  ]))
}
}

})